// extracted by mini-css-extract-plugin
module.exports = {"sponsorLogo":"Sponsor_sponsorLogo__lHfg8","sponsor":"Sponsor_sponsor__2pMzC","sponsorName":"Sponsor_sponsorName__2eLSR"};